<template>
  <div>
    <IndicatorsSettings
      ref="settings"
      :themes="themeList"
      url-prefix="/server/config/schemes/indicators/"
      :scheme-id="schemeId"
      config
      @update="updateThemes"
    />
  </div>
</template>

<script>
/**
 * Indicators edition (actually scheme indicators edition)
 *
 * @vue-prop {Array} scheme-id - ID of the scheme containing the theme list given
 * @vue-prop {Array} themes - List of indicator themes
 *
 * @vue-event {Array} save - Emit theme list when save is triggered
 */
import * as toastr from 'toastr';
import cloneDeep from 'lodash/cloneDeep';
import IndicatorsSettings from '@/components/indicators-settings.vue';
import { delayResize, calert } from '@/utils/main';

export default {

  name: 'ConfigSettingsIndicators',

  components: {
    IndicatorsSettings,
  },

  props: {
    schemeId: {
      type: Number,
      required: true,
    },
    themes: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      themeList: [],
    };
  },

  created() {
    // Setup themeList ; cloned to avoid state mutation
    const themes = cloneDeep(this.themes);
    themes.forEach((t) => {
      t.expanded = false;
      t.indicators.forEach((i) => {
        i.expanded = false;
      });
    });
    this.themeList = themes;
  },

  methods: {
    /** Event handler - Triggered when save button is pushed */
    onSave() {
      this.$emit('save', this.themeList);
    },
    /** Setup themes after an update */
    updateThemes(data) {
      toastr.remove();
      toastr.success(this.$t('message.INDICATORS_SAVED'));
      const tExpanded = {};
      const iExpanded = {};
      this.themeList.forEach(t => {
        tExpanded[`${t.id}`] = t.expanded;
        t.indicators.forEach(i => {
          iExpanded[`${i.id}`] = i.expanded;
        });
      });
      data.forEach(t => {
        t.expanded = !!tExpanded[`${t.id}`];
        t.indicators.forEach(i => {
          i.expanded = !!iExpanded[`${i.id}`];
        });
      });
      this.themeList = data;
    },
  },
};
</script>
